var map = {
	"./aspas.png": 8758,
	"./aspas2.png": 5782,
	"./feminino.png": 3943,
	"./images/Elementos/Layout Portal de Recordações-15.png": 2744,
	"./images/Elementos/branco.png": 6025,
	"./images/Elementos/casal.png": 6480,
	"./images/Elementos/depoimentos.png": 681,
	"./images/Elementos/fundo-section2.png": 6598,
	"./images/Elementos/fundo.png": 7836,
	"./images/Elementos/icons.png": 5582,
	"./images/Elementos/logosempresas.png": 676,
	"./images/Elementos/memorial.png": 3972,
	"./images/icons/book.png": 6993,
	"./images/icons/book_white.png": 1703,
	"./images/icons/chat.png": 9724,
	"./images/icons/chat_white.png": 9354,
	"./images/icons/cross.png": 1944,
	"./images/icons/div-nav.png": 3945,
	"./images/icons/servicos.png": 7712,
	"./images/icons/servicos_white.png": 2574,
	"./images/icons/star.png": 2886,
	"./images/icons/virtual.png": 5073,
	"./images/icons/virtual_white.png": 9159,
	"./images/logos/AFlorDoCafe.png": 7390,
	"./images/logos/CemiterioPrevida.png": 2968,
	"./images/logos/Floresvida.png": 4723,
	"./images/logos/GRUPOPARQUE.png": 4113,
	"./images/logos/LogoGrupoParqueBranca.png": 2711,
	"./images/logos/Memorial.png": 3806,
	"./images/logos/MemorialFlores.png": 3067,
	"./images/logos/ParqueAgreste.png": 2537,
	"./images/logos/ParqueFlores.png": 8965,
	"./images/logos/Previda.png": 2251,
	"./images/logos/grupoparque2.png": 9799,
	"./images/logos/grupoparque3.png": 6782,
	"./images/logos/logo_memorial_branca.png": 8812,
	"./images/logos_footer/aflordocafe.png": 60,
	"./images/logos_footer/cemiterioprevida.png": 574,
	"./images/logos_footer/memorial.png": 2768,
	"./images/logos_footer/memorialflores.png": 4581,
	"./images/logos_footer/parquedasflores.png": 1373,
	"./images/logos_footer/parquedoagreste.png": 6478,
	"./images/logos_footer/previda.png": 3337,
	"./images/qr_code_flor_cafe.png": 8282,
	"./images/ramalhete-direita.png": 8605,
	"./images/ramalhete.png": 6160,
	"./masculino.png": 6719
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 715;